export type CheckoutHeaderQuote = {
  amount: number | null;
  travelers: number;
  currency: string;
  display?: {
    perPerson: string;
    total: string;
  };
};

export function formatCheckoutQuoteDisplay(quote: {
  amount: number;
  travelers: number;
  currency: string;
}) {
  const travelers = quote.travelers > 0 ? quote.travelers : 1;
  const perPerson = quote.amount / travelers;

  return {
    perPerson: `${quote.currency} ${perPerson.toFixed(2)}`,
    total: `${quote.currency} ${quote.amount.toFixed(2)}`,
    travelers,
  };
}

export function resolveCheckoutHeaderQuote(quote?: CheckoutHeaderQuote | null) {
  if (!quote) return { source: 'search' as const };
  if (quote.amount == null) return { source: 'pending' as const };

  const travelers = quote.travelers > 0 ? quote.travelers : 1;

  return {
    source: 'quote' as const,
    display: quote.display
      ? {
          perPerson: quote.display.perPerson,
          total: quote.display.total,
          travelers,
        }
      : formatCheckoutQuoteDisplay({
          amount: quote.amount,
          travelers,
          currency: quote.currency,
        }),
  };
}
